export default {
  path: 'instant',
  props: true,
  components: {
    default: () =>
      import(
        /* webpackChunkName: "instant-match-layout" */ '@/modules/instant/InstantMatchLayout.vue'
      ),
    overlay: () =>
      import(
        /* webpackChunkName: "overlay-tournament-details" */ '@/modules/tournament/views/OverlayTournamentCatalog'
      )
  },
  children: [
    {
      path: '',
      name: 'AutomatedTournament',
      redirect: {
        name: 'InstantMatchCatalog'
      }
    },
    {
      path: 'catalog',
      name: 'InstantMatchCatalog',
      component: () =>
        import(
          /* webpackChunkName: "instant-match-catalog" */ '@/modules/instant/views/InstantMatchCatalog'
        )
    },
    {
      path: 'past',
      name: 'InstantMatchPastTournament',
      component: () =>
        import(
          /* webpackChunkName: "instant-match-catalog" */ '@/modules/instant/views/InstantMatchPastTournament'
        )
    },
    {
      path: 'catalog/:gameCode/:region?',
      name: 'InstantMatchCatalogMobile',
      props: true,
      meta: {
        hasBackButton: true
      },
      component: () =>
        import(
          /* webpackChunkName: "instant-match-catalog-mobile" */ '@/modules/instant/views/InstantMatchCatalogMobile'
        )
    },
    {
      path: ':tournamentId/',
      props: true,
      name: 'InstantMatchDetails',
      component: () =>
        import(
          /* webpackChunkName: "instant-match-details-layout" */ '@/modules/instant/InstantMatchDetailsLayout.vue'
        ),
      children: [
        {
          path: 'details',
          name: 'InstantMatchDetailsSummary',
          meta: {
            defaultTab: 'overview'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details" */ '@/modules/instant/views/InstantMatchDetails'
            )
        },
        {
          path: 'overview',
          name: 'InstantMatchDetailsOverview',
          meta: {
            defaultTab: 'overview'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details-overview" */ '@/modules/tournament/components/TournamentDetailsOverview'
            )
        },
        {
          path: 'rule',
          name: 'InstantMatchtDetailsRule',
          props: true,
          meta: {
            defaultTab: 'rule'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details-rule" */ '@/modules/tournament/components/TournamentDetailsRule'
            )
        },
        {
          path: 'bracket',
          name: 'InstantMatchDetailsBracket',
          props: true,
          meta: {
            defaultTab: 'bracket'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details-bracket" */ '@/modules/tournament/components/TournamentDetailsBracket'
            )
        },
        {
          path: 'teams',
          name: 'InstantMatchDetailsTeams',
          props: true,
          meta: {
            defaultTab: 'players'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details-teams" */ '@/modules/tournament/components/TournamentDetailsTeams'
            )
        },
        {
          path: 'lfg',
          name: 'InstantMatchDetailsLFG',
          props: true,
          meta: {
            defaultTab: 'players'
          },
          component: () =>
            import(
              /* webpackChunkName: "instant-match-details-lfg" */ '@/modules/tournament/components/TournamentDetailsLFG'
            )
        }
      ]
    }
  ]
}
